import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountSentimentReportPercentilesSummaryRequestDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-percentiles-summary.request.dto';
import { AccountSentimentReportPercentilesSummaryAggregateRoot } from '../../../core/domain/aggregates/sentiment/account-sentiment-report-percentiles-summary.aggregate-root';
import { GetAccountSentimentReportPercentilesSummaryApplicationService } from '../../../core/application/services/sentiment/get-account-sentiment-report-percentiles-summary.application-service';

export class GetAccountSentimentReportPercentilesSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountSentimentReportPercentilesSummaryApplicationService
  ) {}
  async execute(
    props: GetAccountSentimentReportPercentilesSummaryRequestDto
  ): Promise<AccountSentimentReportPercentilesSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
